import Head from "next/head";

import ContactUs from "@/components/contact/contact-us";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Contact() {
  return (
    <>
      <Head>
        <title>{seoData.CONTACT_US.title}</title>
        <SeoMetaData data={seoData.CONTACT_US} />
      </Head>

      <ContactUs />
    </>
  );
}
